/**
 * time.ts — Europe/Berlin timestamp formatters (D-09).
 *
 * All times in the admin app render in German time (Europe/Berlin).
 */

const BERLIN = 'Europe/Berlin';

const dtFull = new Intl.DateTimeFormat('de-DE', {
  timeZone: BERLIN,
  dateStyle: 'short',
  timeStyle: 'medium',
});

const dtDate = new Intl.DateTimeFormat('de-DE', {
  timeZone: BERLIN,
  dateStyle: 'short',
});

const dtTime = new Intl.DateTimeFormat('de-DE', {
  timeZone: BERLIN,
  timeStyle: 'short',
});

/** Formats an ISO string or Date to a full date+time in Europe/Berlin. */
export function formatBerlin(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  try {
    return dtFull.format(typeof iso === 'string' ? new Date(iso) : iso);
  } catch {
    return String(iso);
  }
}

/** Formats an ISO string or Date to a date-only string in Europe/Berlin. */
export function formatBerlinDate(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  try {
    return dtDate.format(typeof iso === 'string' ? new Date(iso) : iso);
  } catch {
    return String(iso);
  }
}

/** Formats an ISO string or Date to a time-only string in Europe/Berlin. */
export function formatBerlinTime(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  try {
    return dtTime.format(typeof iso === 'string' ? new Date(iso) : iso);
  } catch {
    return String(iso);
  }
}
